export default __webpack_public_path__ + "static/media/aircare-inside-7.47f73426.png";